import { Button } from "@/components/ui/button";
import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";

export const Datenschutz = () => {
  return (
    <div className="min-h-screen bg-background">
      <div className="container mx-auto px-4 lg:px-8 py-20">
        <Button variant="ghost" asChild className="mb-8 gap-2">
          <Link to="/">
            <ArrowLeft className="h-4 w-4" />
            Zurück zur Startseite
          </Link>
        </Button>
        
        <div className="max-w-3xl">
          <h1 className="font-display text-4xl font-bold text-foreground mb-8">
            Datenschutzerklärung
          </h1>
          
          <div className="prose prose-lg max-w-none">
            <h2 className="font-display text-2xl font-semibold text-foreground mt-8 mb-4">
              1. Datenschutz auf einen Blick
            </h2>
            <h3 className="font-display text-xl font-semibold text-foreground mt-6 mb-3">
              Allgemeine Hinweise
            </h3>
            <p className="text-muted-foreground mb-4">
              Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren 
              personenbezogenen Daten passiert, wenn Sie diese Website besuchen. Personenbezogene 
              Daten sind alle Daten, mit denen Sie persönlich identifiziert werden können.
            </p>
            
            <h3 className="font-display text-xl font-semibold text-foreground mt-6 mb-3">
              Datenerfassung auf dieser Website
            </h3>
            <p className="text-muted-foreground mb-4">
              <strong>Wer ist verantwortlich für die Datenerfassung auf dieser Website?</strong><br />
              Die Datenverarbeitung auf dieser Website erfolgt durch den Websitebetreiber. 
              Dessen Kontaktdaten können Sie dem Impressum dieser Website entnehmen.
            </p>
            
            <h2 className="font-display text-2xl font-semibold text-foreground mt-8 mb-4">
              2. Hosting
            </h2>
            <p className="text-muted-foreground mb-4">
              Wir hosten die Inhalte unserer Website bei folgendem Anbieter:
              [Hosting-Anbieter - Platzhalter]
            </p>
            
            <h2 className="font-display text-2xl font-semibold text-foreground mt-8 mb-4">
              3. Allgemeine Hinweise und Pflichtinformationen
            </h2>
            <h3 className="font-display text-xl font-semibold text-foreground mt-6 mb-3">
              Datenschutz
            </h3>
            <p className="text-muted-foreground mb-4">
              Die Betreiber dieser Seiten nehmen den Schutz Ihrer persönlichen Daten sehr ernst. 
              Wir behandeln Ihre personenbezogenen Daten vertraulich und entsprechend den 
              gesetzlichen Datenschutzvorschriften sowie dieser Datenschutzerklärung.
            </p>
            
            <h3 className="font-display text-xl font-semibold text-foreground mt-6 mb-3">
              Hinweis zur verantwortlichen Stelle
            </h3>
            <p className="text-muted-foreground mb-4">
              Die verantwortliche Stelle für die Datenverarbeitung auf dieser Website ist:<br /><br />
              Lack Zentrum Wilke GmbH<br />
              Silberbergweg 30<br />
              39128 Magdeburg<br /><br />
              Telefon: 0391 635 771 15<br />
              E-Mail: info@lackzentrum-wilke.com
            </p>
            
            <h2 className="font-display text-2xl font-semibold text-foreground mt-8 mb-4">
              4. Datenerfassung auf dieser Website
            </h2>
            <h3 className="font-display text-xl font-semibold text-foreground mt-6 mb-3">
              Server-Log-Dateien
            </h3>
            <p className="text-muted-foreground mb-4">
              Der Provider der Seiten erhebt und speichert automatisch Informationen in 
              so genannten Server-Log-Dateien, die Ihr Browser automatisch an uns übermittelt. 
              Dies sind:
            </p>
            <ul className="list-disc list-inside text-muted-foreground mb-4 space-y-1">
              <li>Browsertyp und Browserversion</li>
              <li>verwendetes Betriebssystem</li>
              <li>Referrer URL</li>
              <li>Hostname des zugreifenden Rechners</li>
              <li>Uhrzeit der Serveranfrage</li>
              <li>IP-Adresse</li>
            </ul>
            
            <h3 className="font-display text-xl font-semibold text-foreground mt-6 mb-3">
              Anfrage per E-Mail oder Telefon
            </h3>
            <p className="text-muted-foreground mb-4">
              Wenn Sie uns per E-Mail oder Telefon kontaktieren, wird Ihre Anfrage inklusive 
              aller daraus hervorgehenden personenbezogenen Daten (Name, Anfrage) zum Zwecke 
              der Bearbeitung Ihres Anliegens bei uns gespeichert und verarbeitet.
            </p>
            
            <h2 className="font-display text-2xl font-semibold text-foreground mt-8 mb-4">
              5. Ihre Rechte
            </h2>
            <p className="text-muted-foreground mb-4">
              Sie haben jederzeit das Recht, unentgeltlich Auskunft über Herkunft, Empfänger 
              und Zweck Ihrer gespeicherten personenbezogenen Daten zu erhalten. Sie haben 
              außerdem ein Recht, die Berichtigung oder Löschung dieser Daten zu verlangen.
            </p>
            
            <h2 className="font-display text-2xl font-semibold text-foreground mt-8 mb-4">
              6. Google Maps
            </h2>
            <p className="text-muted-foreground mb-4">
              Diese Seite nutzt den Kartendienst Google Maps. Anbieter ist die Google Ireland 
              Limited, Gordon House, Barrow Street, Dublin 4, Irland. Die Nutzung von Google Maps 
              erfolgt im Interesse einer ansprechenden Darstellung unseres Standorts.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Datenschutz;
